export class JoinDto {
    public email!: string;
    public name!: string;
    public password!: string;

    public isValid(passwordConfirm: string): boolean {
        if (this.email == undefined || this.email.length == 0
            || this.password == undefined || this.password.length == 0
            || this.password != passwordConfirm) {
            return false;
        }

        return true;
    }
}